<template>
    <div class="container">
        <!-- Título -->
        <div class="col-md-12">
            <h3><b><i>{{ f_titulo() }}</i></b></h3>
        </div>

        <!-- Filtros principales -->
        <b-container>
            <b-row class="mb-4 align-items-center text-lg">
                <!-- Vigencia  -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.vigencia }}</b></label>
                    <input type="month" v-model="selVigencia" @change="f_validatePeriodo"
                        class="form-control form-control-lg"
                        :class="{ 'disabled-period-input': isPeriodoDeshabilitado(selVigencia) }">
                    <small v-if="selVigencia && isPeriodoDeshabilitado(selVigencia)" class="text-danger">
                        <b-icon-exclamation-triangle></b-icon-exclamation-triangle>
                        Este período está deshabilitado para carga de datos
                    </small>
                </b-col>

                <!-- Alerta de período deshabilitado -->
                <b-row v-if="selVigencia && isPeriodoDeshabilitado(selVigencia)" class="mb-4">
                    <b-col>
                        <b-alert show variant="danger" class="text-center">
                            <b-icon-exclamation-octagon font-scale="2" class="mr-2"></b-icon-exclamation-octagon>
                            <strong>PERÍODO DESHABILITADO:</strong> No se pueden cargar datos para el período
                            {{ formatFecha(selVigencia) }} porque ha sido deshabilitado por el administrador.
                            <br>
                            <small>Si necesita cargar información para este período, contacte al administrador.</small>
                        </b-alert>
                    </b-col>
                </b-row>

                <!-- Grupo -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.group }}</b></label>
                    <select v-model="grupoId" @change="f_filterCompany" class="form-control form-control-lg">
                        <option value="">Todos los grupos</option>
                        <option v-for="grupo in listGrupos" :key="grupo.id" :value="grupo.id">
                            {{ grupo.nombre }}
                        </option>
                    </select>
                </b-col>

                <!-- Compañía -->
                <b-col md="4">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.company }}</b></label>
                    <select v-model="companyId" @change="f_valide_formato" class="form-control form-control-lg">
                        <option value="">{{ labels.seleccione }}</option>
                        <option v-for="company in filteredCompany" :key="company.id" :value="company.id">
                            {{ company.acronym }} {{ company.nombre }}
                        </option>
                    </select>
                </b-col>
            </b-row>

            <!-- Botones de acción -->
            <b-row v-if="selVigencia && companyId && currencyCTA" class="mb-4 align-items-center text-lg">
                <b-col>
                    <b-button @click="f_calcula_cta()" id="consult-btn">{{ labels.calculeCTA }}</b-button>
                </b-col>
            </b-row>

            <!-- Carga de archivo -->
            <b-row v-if="selVigencia && companyId && formato_asignado" class="mb-4 align-items-center text-lg">
                <b-col md="6">
                    <label class="d-block fw-bold" style="font-size: 1.3rem;"><b>Archivo Excel</b></label>
                    <input id="archivoExcel" type="file" @change="cargaExcel()" class="form-control form-control-lg" accept=".xlsx, .xls">
                </b-col>

                <b-col v-if="muestraHoja" md="6">
                    <label class="block fw-bold" style="font-size: 1.3rem;"><b>{{ labels.hoja }}</b></label>
                    <select v-model="selectedHoja" @change="f_showHoja()" class="form-control form-control-lg">
                        <option value="">{{ labels.seleccione }}</option>
                        <option v-for="(item, idx) in listHojas" :value="item" :key="idx">{{ item }}</option>
                    </select>
                </b-col>
            </b-row>

            <!-- Botón cargar hoja  -->
            <b-row v-if="showBtnHoja == true" class="mb-4">
                <b-col>
                    <b-button @click="showConfirmationModal()" id="consult-btn"
                        :disabled="isPeriodoDeshabilitado(selVigencia)"
                        :variant="isPeriodoDeshabilitado(selVigencia) ? 'secondary' : 'primary'">
                        {{ labels.chargeHoja }}
                    </b-button>
                    <span v-if="isPeriodoDeshabilitado(selVigencia)" class="text-danger ml-2">
                        <small><i class="fas fa-lock"></i> Período bloqueado</small>
                    </span>
                </b-col>
            </b-row>
        </b-container>

        <!-- TARJETA DE HISTORIAL RECIENTE -->
        <b-container class="mt-5">
            <b-card header="Historial de Cargas Recientes" header-tag="h4" class="shadow-sm">
                <b-row>
                    <b-col md="12">
                        <b-table 
                            :items="historial" 
                            :fields="historialFields" 
                            small 
                            responsive 
                            striped 
                            hover
                            show-empty
                            empty-text="No hay cargas recientes">
                            
                            <template #cell(vigencia_formateada)="data">
                                <span class="badge badge-primary">{{ data.value }}</span>
                            </template>
                            
                            <template #cell(fecha_carga)="data">
                                <small><i class="far fa-calendar-alt mr-1"></i>{{ data.value }}</small>
                            </template>
                            
                            <template #cell(usuario_creador)="data">
                                <small><i class="far fa-user mr-1"></i>{{ data.value }}</small>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col class="text-right">
                        <b-button size="sm" variant="outline-info" class="btn-actualizar" @click="verHistorial()">
                            <i class="fas fa-sync-alt"></i> Actualizar
                        </b-button>
                        <small class="text-muted ml-2">Últimas 10 cargas</small>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>

        <!-- Loading spinner -->
        <div v-if="!isLoading"></div>
        <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
        </div>

        <!-- MODAL DE CONFIRMACIÓN -->
        <b-modal v-model="showConfirmModal" title="Confirmar Carga de Archivo" hide-footer centered
            no-close-on-backdrop no-close-on-esc>
            <div class="text-center">
                <!-- Información de la carga -->
                <div class="confirmation-info mb-4">
                    <p><strong>Fecha seleccionada:</strong> {{ formatFecha(selVigencia) }}</p>
                    <p><strong>Compañía:</strong> {{ getCompanyName() }}</p>
                    <p><strong>Archivo:</strong> {{ getFileName() }}</p>
                    <p><strong>Hoja seleccionada:</strong> {{ selectedHoja }}</p>
                </div>

                <!-- Mensaje de advertencia -->
                <div class="alert alert-warning" role="alert">
                    <i class="fas fa-exclamation-triangle"></i>
                    Por favor verifique que la fecha sea correcta. Esta acción no se puede deshacer.
                </div>

                <!-- Botones -->
                <div class="mt-4">
                    <b-button 
                        @click="confirmAndLoad()" 
                        variant="primary" 
                        :disabled="!confirmButtonEnabled"
                        :class="{ 'btn-secondary': !confirmButtonEnabled }"
                        size="lg"
                        block>
                        {{ confirmButtonEnabled ? 'Aceptar y Cargar' : `Esperar ${countdown} segundos` }}
                    </b-button>
                    <b-button @click="cancelConfirmation()" variant="outline-secondary" block class="mt-2">
                        Cancelar
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- MODAL DE PROGRESO -->
        <b-modal v-model="showProgressModal" title="Cargando Archivo" hide-footer centered
            no-close-on-backdrop no-close-on-esc>
            <div class="text-center">
                <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
                <h5 class="mt-3">
                    <b><i>{{ progressMessage }}</i></b>
                </h5>
                <p class="mt-2">{{ progressSubMessage }}</p>
                <b-progress v-if="progressValue >= 0" class="mt-3">
                    <b-progress-bar :value="progressValue" :label="`${progressValue}%`"
                        variant="primary" striped animated>
                    </b-progress-bar>
                </b-progress>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Company from "../../services/Company"
import Cargue from "../../services/Cargue";
import * as XLSX from "xlsx"
import Grupo from "../../services/Grupo"

export default {
    name: "CargueBalance",
    data: () => ({
        listGrupos: [],
        grupoId: "",
        filteredCompany: [],
        listCompany: [],
        listVigencia: [],
        companyId: "",
        selVigencia: "",
        formato_asignado: false,
        listCuenta: [],
        listHojas: [],
        showBtnHoja: false,
        isLoading: false,
        inputArch: "",
        workbook: "",
        muestraHoja: false,
        selHoja: false,
        selectedHoja: '',
        fileReader: '',
        formato: '',
        currencyCTA: false,
        showConfirmModal: false,
        showProgressModal: false,
        confirmButtonEnabled: false,
        countdown: 5,
        countdownInterval: null,
        progressValue: 0,
        progressMessage: 'Iniciando carga...',
        progressSubMessage: 'Procesando archivo Excel',
        fileName: '',
        historialLoading: false,
        historial: [],
        historialFields: [
            { key: 'vigencia_formateada', label: 'Vigencia', sortable: true },
            { key: 'company', label: 'Compañía', sortable: true },
            { key: 'fecha_carga', label: 'Fecha Carga', sortable: true },
            { key: 'usuario_creador', label: 'Usuario', sortable: true }
        ],
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "CARGUE BALANCE FORMATO EXCEL SIN INFORMACION NIIF",
                    company: "Compañía:",
                    group: "Grupo",
                    vigencia: "Vigencia:",
                    charge: "Cargar",
                    chargeHoja: "Cargar Hoja",
                    calculeCTA: "Currency Traslate Adjustment",
                    seleccione: "Seleccione.....",
                    hoja: "Hoja"
                }
            } else {
                return {
                    title: "LOAD BALANCE SHEET EXCEL FORMAT WITHOUT NIIF INFORMATION",
                    company: "Company:",
                    group: "Group",
                    vigencia: "Validity:",
                    charge: "Charge",
                    calculeCTA: "Currency Traslate Adjustment",
                    chargeHoja: "Charge Sheet",
                    seleccione: "Select.....",
                    hoja: "Sheet"
                }
            }
        }
    },

    watch: {
        selVigencia(newVal) {
            if (newVal && this.isPeriodoDeshabilitado(newVal)) {
                // Limpiar datos dependientes
                this.companyId = ""
                this.formato_asignado = false
                this.currencyCTA = false
                this.showBtnHoja = false
                this.muestraHoja = false
                this.selectedHoja = ''

                // Mensaje informativo
                this.$bvToast.toast(
                    `El período ${this.formatFecha(newVal)} está deshabilitado. No se permiten cargas.`,
                    {
                        title: 'Período Bloqueado',
                        variant: 'warning',
                        solid: true,
                        autoHideDelay: 4000
                    }
                )
            }
        }
    },            
    methods: {
        f_titulo() {
            let titulo = ""
            let tituloEN = ""
            titulo = "PROCESO DE CARGUE DE BALANCES"
            tituloEN = "ACCOUNTING BALANCE UPLOAD PROCESS"
            if (this.$store.state._language != "es-ES") {
                titulo = tituloEN
            }
            if (this.formato) {
                titulo = this.f_titulo_cargue()
            }
            return titulo
        },

        // MÉTODO NUEVO: Filtrar compañías por grupo
        f_filterCompany() {
            console.log('=== INICIO FILTRO ===');
            console.log('Grupo seleccionado (ID):', this.grupoId);

            if (this.grupoId) {
                const grupoIdNum = this.grupoId.toString(); // Convertir a string para comparar

                // Encontrar el grupo seleccionado para mostrar su nombre
                const grupoSeleccionado = this.listGrupos.find(g => g.id === parseInt(grupoIdNum));
                console.log('Grupo seleccionado (Objeto):', grupoSeleccionado);

                // Filtrar compañías - BUSCAR EN EL STRING
                this.filteredCompany = this.listCompany.filter(company => {
                    if (!company.id_grupos) return false;

                    const gruposCompania = company.id_grupos
                        .split(',')
                        .map(id => id.trim());

                    const coincide = gruposCompania.includes(grupoIdNum);
                    console.log(`Compañía: ${company.nombre}, id_grupos: ${company.id_grupos}, Coincide: ${coincide}`);
                    return coincide;
                });

                console.log('Resultado del filtro:', this.filteredCompany.map(c => c.nombre));
            } else {
                console.log('Mostrando TODAS las compañías');
                this.filteredCompany = this.listCompany;
            }

            this.companyId = "";
            this.formato_asignado = false;
            console.log('=== FIN FILTRO ===');
        },

        f_titulo_cargue() {
            let titulo = ""
            let tituloEN = ""
            switch (this.formato) {
                case 1:
                    titulo = "CARGUE BALANCE EXCEL UNIVERSIDAD EL BOSQUE"
                    tituloEN = "LOAD BALANCE SHEET EXCEL UNIVERSIDAD EL BOSQUE"
                    break;
                case 2:
                    titulo = "CARGUE BALANCE EXCEL IPS EL BOSQUE"
                    tituloEN = "LOAD BALANCE EXCEL IPS EL BOSQUE"
                    break;
                case 3:
                    titulo = "CARGUE BALANCE FORMATO 3"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 3"
                    break;
                case 4:
                    titulo = "CARGUE BALANCE FORMATO 4"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 4"
                    break;
                case 5:
                    titulo = "CARGUE BALANCE FORMATO 5"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 5"
                    break;
                case 6:
                    titulo = "CARGUE BALANCE FORMATO 6"
                    tituloEN = "LOAD BALANCE SHEET FORMAT 6"
                    break;
            }
            if (this.$store.state._language != "es-ES") {
                titulo = tituloEN
            }
            return titulo
        },
        f_calcula_cta() {
            const selVigencia = this.selVigencia.replace("-", "")
            const companyId = this.companyId
            this.selVigencia = ''
            this.companyId = ''
            this.formato_asignado = false
            let v_error = false
            Cargue.calculaCTA(selVigencia, companyId, this.$store.state.userId)
                .then((res) => {
                    if (res.status !== 200) {
                        v_error = false
                    } else {
                        v_error = true
                    }
                })
            if (v_error) {
                this.$toast.error("Problema al generar CTA")
            } else {
                this.$toast.success("CTA Generado")
            }
        },
        cargaExcel() {
            this.showBtnHoja = false
            this.muestraHoja = false
            this.selHoja = false
            this.selectedHoja = false
            const inputArch = document.getElementById("archivoExcel")
            var selectedFile = inputArch.files[0]
            this.fileName = selectedFile ? selectedFile.name : '';
            this.fileReader = new FileReader();
            this.fileReader.onload = function (event) {
                var data = event.target.result
                this.workbook = XLSX.read(data, { type: "binary" })
                let hojas = this.workbook.SheetNames
                this.listHojas = hojas
            };
            if (selectedFile) {
                this.fileReader.readAsBinaryString(selectedFile)
                setTimeout(() => {
                    this.muestraHoja = true
                    this.listHojas = this.fileReader.listHojas
                }, 2000)
            }
        },

        cancelConfirmation() {
            this.showConfirmModal = false;
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }
        },


        // Método para iniciar el countdown de 5 segundos
        startCountdown() {
            this.confirmButtonEnabled = false;
            this.countdown = 5;

            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }

            this.countdownInterval = setInterval(() => {
                this.countdown -= 1;
                if (this.countdown <= 0) {
                    this.confirmButtonEnabled = true;
                    clearInterval(this.countdownInterval);
                }
            }, 1000);
        },

        isPeriodoDeshabilitado(periodo) {
            if (!periodo) return false
            const periodoFormateado = periodo.replace('-', '')
            return !this.$store.getters.isPeriodoEnabled(periodoFormateado)
        },

        f_validatePeriodo() {
            if (this.selVigencia && this.isPeriodoDeshabilitado(this.selVigencia)) {
                this.$bvToast.toast(
                    `No se puede trabajar con el período ${this.formatFecha(this.selVigencia)} porque está deshabilitado por el administrador.`,
                    {
                        title: 'Período Deshabilitado',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 5000
                    }
                )
                this.companyId = ""
                this.formato_asignado = false
                this.currencyCTA = false
                return false
            }
            return true
        },

        f_valide_formato() {
  
            if (!this.f_validatePeriodo()) {
                return
            }

            this.currencyCTA = false
            this.formato_asignado = false
            let objFormato = this.listCompany.find((obj) => obj.id === this.companyId)
            this.formato = objFormato.formato
            if (this.formato) {
                this.formato_asignado = true
                if (objFormato.id_moneda != 2) {
                    this.currencyCTA = true
                }
            } else {
                this.$toast.success(objFormato.nombre + " sin formato asignado")
            }
        },

        showConfirmationModal() {
            if (!this.selVigencia) {
                this.$bvToast.toast('Debe seleccionar una vigencia primero', {
                    title: 'Validación',
                    variant: 'warning',
                    solid: true
                })
                return
            }

            if (this.isPeriodoDeshabilitado(this.selVigencia)) {
                this.$bvToast.toast(
                    `No se puede cargar datos para el período ${this.formatFecha(this.selVigencia)} porque está deshabilitado.`,
                    {
                        title: 'Acción Bloqueada',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 5000
                    }
                )
                return
            }

            this.showConfirmModal = true;
            this.startCountdown();
        },

        confirmAndLoad() {
            if (this.isPeriodoDeshabilitado(this.selVigencia)) {
                this.showConfirmModal = false;
                this.$bvToast.toast('No se puede proceder con la carga: período deshabilitado', {
                    title: 'Error de Seguridad',
                    variant: 'danger',
                    solid: true
                })
                return
            }

            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }

            this.showConfirmModal = false;

            this.cargaBalanceSeleccionado();
        },

        cambFormatoVigencia() {
            let anio = this.selVigencia.substring(0, 4)
            let mes = this.selVigencia.substring(5, 7)
            let newMes = mes
            return anio + newMes
        },

        formatFecha(fecha) {
            if (!fecha) return 'No seleccionada';
            const [year, month] = fecha.split('-');
            const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            return `${meses[parseInt(month) - 1]} ${year}`;
        },

        getCompanyName() {
            if (!this.companyId) return 'No seleccionada';
            const company = this.listCompany.find(c => c.id === this.companyId);
            return company ? `${company.acronym} ${company.nombre}` : 'No encontrada';
        },

        getFileName() {
            return this.fileName || 'No seleccionado';
        },

        simulateProgress() {
            this.progressValue = 0;
            this.progressMessage = 'Cargando archivo...';
            this.progressSubMessage = 'Procesando datos del Excel';

            const progressInterval = setInterval(() => {
                if (this.progressValue < 90) {
                    this.progressValue += 10;
                    if (this.progressValue === 30) {
                        this.progressSubMessage = 'Validando información';
                    } else if (this.progressValue === 60) {
                        this.progressSubMessage = 'Guardando en base de datos';
                    }
                } else {
                    clearInterval(progressInterval);
                }
            }, 500);

            return progressInterval;
        },

        cargaBalanceSeleccionado() {
            // Mostrar modal de progreso
            this.showProgressModal = true;
            this.progressValue = 0;

            // Simular progreso inicial
            const progressInterval = this.simulateProgress();

            let rowObject = XLSX.utils.sheet_to_row_object_array(
                this.fileReader.workbook.Sheets[this.selectedHoja])
            this.listCuenta = []
            rowObject.forEach(fila => {
                var columnas = Object.values(fila)
                this.listCuenta.push(columnas)
            })
            let form = {
                "vigencia": this.cambFormatoVigencia(),
                "company": this.companyId,
                "listadoCuentas": this.listCuenta,
                'idUser': this.$store.state.userId
            }
            let v_error = false

            // Función para manejar la respuesta
            const handleResponse = (res) => {
                if (res.status !== 200) {
                    v_error = true;
                    this.progressMessage = 'Error en la carga';
                    this.progressSubMessage = 'Por favor intente nuevamente';
                    this.$toast.error("Problema al Cargar");
                } else {
                    v_error = false;
                    this.progressValue = 100;
                    this.progressMessage = '¡Carga completada!';
                    this.progressSubMessage = 'Actualizando información NIIF';

                    setTimeout(() => {
                        this.actualizaNiif(form.vigencia, form.company)
                        setTimeout(() => {
                            this.showProgressModal = false;
                            this.resetForm();
                        }, 2000);
                    }, 10000);
                }

                clearInterval(progressInterval);
            };

            switch (this.formato) {
                case 1:
                    Cargue.cargaBalace(form)
                        .then((res) => handleResponse(res))
                    break;
                case 2:
                    Cargue.cargaBalaceF2(form)
                        .then((res) => handleResponse(res))
                    break;
                case 3:
                    Cargue.cargaBalaceF3(form)
                        .then((res) => handleResponse(res))
                    break;
                case 4:
                    Cargue.cargaBalaceF4(form)
                        .then((res) => handleResponse(res))
                    break;
                case 5:
                    Cargue.cargaBalaceF5(form)
                        .then((res) => handleResponse(res))
                    break;
                case 6:
                    Cargue.cargaBalaceF6(form)
                        .then((res) => handleResponse(res))
                    break;
                case 7:
                    Cargue.cargaBalaceF7(form)
                        .then((res) => handleResponse(res))
                    break;
                case 8:
                    Cargue.cargaBalaceF8(form)
                        .then((res) => handleResponse(res))
                    break;
                case 9:
                    Cargue.cargaBalaceF9(form)
                        .then((res) => handleResponse(res))
                    break;
                case 10:
                    Cargue.cargaBalaceF10(form)
                        .then((res) => handleResponse(res))
                    break;
                case 100:
                    Cargue.cargaBalaceF100(form)
                        .then((res) => handleResponse(res))
                    break;
                case 200:
                    Cargue.cargaBalaceF200(form)
                        .then((res) => handleResponse(res))
                    break;
                case 300:
                    Cargue.cargaBalaceF300(form)
                        .then((res) => handleResponse(res))
                    break;
                case 400:
                    Cargue.cargaBalaceF400(form)
                        .then((res) => handleResponse(res))
                    break;
                case 500:
                    Cargue.cargaBalaceF500(form)
                        .then((res) => handleResponse(res))
                    break;
                case 600:
                    Cargue.cargaBalaceF600(form)
                        .then((res) => handleResponse(res))
                    break;
            }
            if (!v_error) {
                this.showBtnHoja = false
            }
        },
        actualizaNiif(p_vigencia, p_compania) {
            Cargue.actualizaNiif(p_vigencia, p_compania)
                .then((res) => {
                    if (res.status === 200) {
                        this.$toast.success("Cargue Completo")
                        this.resetForm();
                    } else {
                        this.$toast.error("Error(1) al Actualizar Niif(Cargue)")
                    }
                })
                .catch(() => {
                    this.$toast.error("Error(2) al Actualizar Niif(Cargue) ")
                })
        },
        f_showHoja() {
            this.showBtnHoja = true
        },
        resetForm() {
            this.grupoId = "";
            this.companyId = "";
            this.selVigencia = "";
            this.formato_asignado = false;
            this.listHojas = [];
            this.showBtnHoja = false;
            this.muestraHoja = false;
            this.selectedHoja = '';
            this.formato = '';
            this.fileName = '';

            // Limpiar el input de archivo
            const inputArch = document.getElementById("archivoExcel");
            if (inputArch) {
                inputArch.value = "";
            }

            // Resetear filteredCompany para mostrar todas las compañías
            this.filteredCompany = this.listCompany;

            // Cerrar modales si están abiertos
            this.showConfirmModal = false;
            this.showProgressModal = false;

            // Limpiar intervalos
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
            }
        },

        verHistorial() {
            this.historialLoading = true;

            this.$store.commit('setLoading', true);

            Cargue.getHistorialCargas()
                .then((response) => {
                    if (response.data.success) {
                        this.historial = response.data.historial;
                        console.log('Historial cargado:', this.historial);
                    } else {
                        this.$toast.error('Error al cargar el historial');
                    }
                })
                .catch((error) => {
                    console.error('Error al obtener historial:', error);
                    this.$toast.error('Error al conectar con el servidor');
                })
                .finally(() => {
                    this.historialLoading = false;
                    this.$store.commit('setLoading', false);
                });
        },
    },
    mounted() {
        this.isLoading = true;

        Grupo.getAllGrupos()
            .then((result) => {
                this.listGrupos = result.data.grupos;
                console.log('Grupos cargados:', this.listGrupos);
                return Company.getAllCompanies();
            })
            .then((result) => {
                this.listCompany = result.data.companies;
                console.log('Compañías cargadas:', this.listCompany);

                // Verificar si tenemos el campo id_grupos
                if (this.listCompany.length > 0) {
                    const primeraCompany = this.listCompany[0];
                    console.log('Primera compañía:', primeraCompany);
                    console.log('Tiene id_grupos?', 'id_grupos' in primeraCompany);
                    console.log('Valor de id_grupos:', primeraCompany.id_grupos);
                    console.log('Nombre del grupo:', primeraCompany.grupo_nombre);
                }

                this.filteredCompany = this.listCompany;
                return Cargue.getVigenciaCargue();
            })
            .then((res) => {
                this.listVigencia = res.data.getVigencia;
                this.verHistorial();
            })
            .catch((err) => {
                console.log(err);
                this.$toast.error('Error al cargar datos');
            })
            .finally(() => {
                this.isLoading = false;
            });
    },
    beforeDestroy() {
        // Limpiar intervalos cuando el componente se destruye
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }
}
</script>

<style scoped>
/* ESTILOS DEL MODAL DE CONFIRMACIÓN */
.confirmation-info {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    text-align: left;
}

.confirmation-info p {
    margin-bottom: 10px;
    font-size: 1.1rem;
}

.confirmation-info p strong {
    color: #2c3e50;
    min-width: 120px;
    display: inline-block;
}

.btn-secondary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.alert-warning {
    background-color: #fff3cd;
    border-color: #ffc107;
    color: #856404;
    border-radius: 8px;
}

.alert-warning i {
    margin-right: 8px;
}

/* ESTILOS DE LA TARJETA DE HISTORIAL */
.card-header {
    background-color: #f8f9fa;
    font-weight: bold;
    border-bottom: 2px solid #17a2b8;
}

.shadow-sm {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
}

/* ESTILOS DE LA TABLA DE HISTORIAL */
.table-sm td, 
.table-sm th {
    padding: 0.5rem;
    font-size: 0.9rem;
}

.badge-primary {
    background-color: #17a2b8;
    padding: 5px 10px;
    font-size: 0.8rem;
}

.table-hover tbody tr:hover {
    background-color: rgba(23, 162, 184, 0.1);
    cursor: pointer;
}

.b-table thead th {
    background-color: #343a40;
    color: white;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 10;
}

/* BOTÓN ACTUALIZAR - VERSIÓN COMPACTA CON LETRA MÁS GRANDE */
.btn-actualizar {
    padding: 0.15rem 0.8rem !important;
    font-size: 0.9rem !important;
    line-height: 1.3 !important;
    height: 32px !important;
    display: inline-flex;
    align-items: center;
}

.btn-actualizar i {
    font-size: 0.85rem;
    margin-right: 4px;
}

/* Ajuste del contenedor para mejor alineación */
.mt-2 .text-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}

/* El texto "Últimas 10 cargas" más pequeño */
.text-muted.small {
    font-size: 0.75rem !important;
}

/* SEPARADOR VISUAL */
.mt-5 {
    margin-top: 3rem !important;
    border-top: 1px solid #dee2e6;
    padding-top: 2rem;
}

.disabled-period-input {
    background-color: #e9ecef !important;
    opacity: 0.7;
    cursor: not-allowed;
    border-color: #dc3545;
}

.disabled-period-input:disabled {
    background-color: #e9ecef;
    opacity: 0.7;
}

/* Estilo para el modal de confirmación cuando hay warning */
.modal-content .alert-danger {
    border-left: 4px solid #dc3545;
}
</style>
